// Utils.js
import Parse from "../../api/ApiConfig";

/**********************
	API functions
**********************/

export const fetchParameters = async () => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		let results = await query.find();
		let parameters = results.map((result) => {
			return {
				id: result.id,
				parameter: result.get("parameter"),
				value: result.get("value"),
				period: result.get("period"),
				term: result.get("term"),
				isVariable: result.get("isVariable"),
			};
		});
		parameters = parameters.filter((parameter) => !parameter.isVariable);
		let variables = results.find((result) => result.get("isVariable"));
		variables = {
			period: JSON.parse(variables.get("periodList")),
			terms: JSON.parse(variables.get("termsList")),
		};

		console.log(parameters, variables);
		return { parameters, variables };
	} catch (error) {
		console.error(error);
	}
};

export const createParameter = async (formData) => {
	try {
		const parameter = new Parse.Object("Parameters");
		parameter.set("parameter", formData.parameter);
		parameter.set("value", formData.value);
		parameter.set("period", formData.period);
		parameter.set("term", formData.term);

		const result = await parameter.save();
		console.log("Parameter created", result);
		return result;
	} catch (error) {
		console.error(error);
	}
};

export const fetchParameterById = async (id) => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		const result = await query.get(id);
		return {
			id: result.id,
			parameter: result.get("parameter"),
			value: result.get("value"),
			period: result.get("period"),
			term: result.get("term"),
		};
	} catch (error) {
		console.error(error);
	}
};

export const updateParameter = async (formData) => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		const parameter = await query.get(formData.id);

		parameter.set("parameter", formData.parameter);
		parameter.set("value", formData.value);
		parameter.set("period", formData.period);
		parameter.set("term", formData.term);

		const result = await parameter.save();
		console.log("Parameter updated", result);
		return result;
	} catch (error) {
		console.error(error);
	}
};

export const updateVariables = async (formData) => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		query.equalTo("isVariable", true);
		const parameter = await query.first();

		parameter.set("periodList", JSON.stringify(formData.period));
		parameter.set("termsList", JSON.stringify(formData.terms));

		const result = await parameter.save();
		console.log("Parameter updated", result);
		return result;
	} catch (error) {
		console.error(error);
	}
};

export const deleteParameter = async (id) => {
	try {
		const Parameters = Parse.Object.extend("Parameters");
		const query = new Parse.Query(Parameters);
		const parameter = await query.get(id);
		const result = await parameter.destroy();
		console.log("Parameter deleted", result);
		return result;
	} catch (error) {
		console.error(error);
	}
};
